<template>
  <section>
    <el-upload
      action="#"
      :class="{ hide: hideUpload }"
      list-type="picture-card"
      :limit="limitCount"
      :show-file-list="show"
      :file-list="fileList"
      name="img"
      ref="uploadimg"
      accept="image/*"
      :on-exceed="handleExceed"
      :auto-upload="false"
      :http-request="httpRequest"
      :on-error="uploadError"
      :on-change="changeImg"
      :before-upload="handleBeforeUpload"
      :multiple="isMultiple"
    >
      <i class="el-icon-plus"></i>
      <div v-if="tips" slot="tip" class="el-upload__tip">{{ tips }}</div>
      <div slot="file" slot-scope="{ file }">
        <img class="el-upload-list__item-thumbnail" :src="file.url" alt="" />
        <span class="el-upload-list__item-actions">
          <span
            class="el-upload-list__item-preview"
            @click="handlePictureCardPreview(file)"
          >
            <i class="el-icon-zoom-in"></i>
          </span>
          <span
            v-if="!disabled"
            class="el-upload-list__item-delete"
            @click="handleRemove(file)"
          >
            <i class="el-icon-delete"></i>
          </span>
        </span>
      </div>
    </el-upload>
    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
  </section>
</template>

<script>
import { deleteAttachment } from "../api/api";
export default {
  name: "ImageFile",
  props: {
    //图片上传限制
    limitCount: {
      type: Number,
      default: 1,
    },
    limitSize: {
      type: Number,
      default: 2048,
    },
    //图片集合
    value: {
      type: Array,
      default: [],
    },
    show: {
      type: Boolean,
      default: true,
    },
    isMultiple: {
      type: Boolean,
      default: false,
    },
    tips: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      //图片预览
      dialogImageUrl: "",
      dialogVisible: false,
      upload_flag: false,
      disabled: false,
      fileList: this.value,
      hideUpload: false,
    };
  },
  methods: {
    //图片上传超过数量限制
    handleExceed(files, fileList) {
      this.$message.error(`上传图片不能超过${this.limitCount}张!`);
    },
    //添加图片后立刻上传到服务器
    httpRequest(param) {},
    // 图片上传失败时
    uploadError() {
      this.$message.error("图片上传失败!");
    },
    validateFileType(file) {
      if (
        !(
          file.raw.type === "image/png" ||
          file.raw.type === "image/gif" ||
          file.raw.type === "image/jpg" ||
          file.raw.type === "image/jpeg"
        )
      ) {
        this.$notify.warning({
          title: "错误提示",
          message:
            "请上传格式为image/png, image/gif, image/jpg, image/jpeg的图片",
        });
        return false;
      }
      return true;
    },
    validateFileSize(file) {
      let size = file.size / 1024;
      if (size > this.limitSize) {
        let tipSize = "";
        if (this.limitSize < 1024) {
          tipSize = this.limitSize + "KB";
        } else {
          tipSize = Number(this.limitSize / 1024).toFixed(0) + "MB";
        }
        this.$notify.error({
          title: "错误提示",
          message: "此处图片大小不得超过" + tipSize,
        });
        return false;
      }
      return true;
    },
    changeImg(file, fileList) {
      if (this.validateFileType(file) && this.validateFileSize(file)) {
        if (file.name) {
          this.upload_flag = true;
        }
        this.fileList.push(file); //以免覆盖已经通过接口上传的文件
        this.$emit("change", this.fileList);
        //判断大于下限定图片数量隐藏添加按钮
        this.hideUpload = this.fileList.length >= this.limitCount;
      }else{
        fileList.pop();
      }
    },
    // 上传文件之前的钩子
    handleBeforeUpload(file) {
      return this.validateFileType(file) && this.validateFileSize(file);
    },

    //预览图片
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },

    //删除图片
    handleRemove(file) {
      this.$confirm("您确定要删除该图片吗？", "提示", {}).then(() => {
        if (file.status == "success") {
          this.addLoading = true;
          let para = {
            id: file.id,
          };
          deleteAttachment(para).then((res) => {
            this.addLoading = false;
            if (res.data.isSuccess) {
              let index = this.fileList.findIndex(x=>x.id==file.id);
              this.fileList.splice(index, 1);
              this.$emit("change", this.fileList);
              this.$message({
                message: res.data.msg,
                type: "success",
              });
              //判断小于开放添加图片按钮
              this.hideUpload = this.fileList.length >= this.limitCount;
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }
          });
        } else {
          var index = this.fileList.findIndex((s) => s.uid == file.uid);
          this.fileList.splice(index, 1);
          this.$emit("change", this.fileList);
          //判断小于开放添加图片按钮
          this.hideUpload = this.fileList.length >= this.limitCount;
        }
      }).catch(err=>{});
    },
  },
  mounted() {
      this.hideUpload = this.fileList.length >= this.limitCount;
  },
  watch: {
    value: {
      handler(newval, oldVal){
        this.fileList = newval;
        this.hideUpload = this.fileList.length >= this.limitCount;
      },
      deep: true,
      immediate: false
    }
  },
};
</script>
<style>
.hide .el-upload--picture-card {
  display: none;
}
.el-upload__tip {
  margin: 0 !important;
  color: rgb(177, 170, 170) !important;
}
</style>